
import { Card, CardContent } from '@material-ui/core';
import React, { Component } from 'react';
import TableWithoutPagination from '../../Table/TableWithoutPagination';

class InterventionDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    Header: "Equipement",
                    id: 'equipment_description',
                    accessor: a => a.equipment_description,
                    Cell: (cellInfo) => {
                        let currentLine = this.props.intervention.lines[cellInfo.index];
                        if (!currentLine)
                            return null;

                        return (
                            <div className="large-text-cell long-text-value">
                                {currentLine.equipment_description}
                            </div>
                        )
                    }
                },
            ]
        }
    }

    render() {
        return (
            <Card className="card">
                <CardContent className="row without-side-padding-only-small-screen">
                    <TableWithoutPagination
                        data={this.props.intervention.lines}
                        columns={this.state.columns}
                    />
                </CardContent>
            </Card>
        );
    }
}

export default InterventionDetails;

